import { Fragment } from "react/jsx-runtime"
import { Col } from "antd"
import { BoothTargetViewGraph } from "../components/booth-target/booth-target-view";

export const BoothsTargetView = () => {

    return (
        <Fragment>
            <Col span={24}>
                <h2 style={{ fontSize: "16px", fontWeight: "500" }}>Booth</h2>
            </Col>
            <BoothTargetViewGraph />
        </Fragment>

    )
}